import {ISearchFilter, ISearchFilterOption, ISearchFilterRangeOption} from '../../../types';

const mapFilters = (response: {
  data: any
}): ISearchFilter[] => {
  return response.data.filter.options.map((filter) => {
    const f: ISearchFilter = {
      identifier: filter.filterOptionId,
      initiallyOpen: false,
      label: filter.label,
      type: null,
      displayType: null,
      options: [],
      raw: filter,
      open: false
    }
    // console.log(filter.displayType)
    switch (filter.displayType) {
      case 'box':
      case 'swatch':
      case 'list':
      case 'rating':
        f.type = filter.selectType === 'multiple' ? 'MULTI_OPTION' : 'SINGLE_OPTION'
        f.displayType = 'TEXT'
        if (filter.displayType === 'box') {
          f.displayType = 'BOX'
        } 
        else if (filter.displayType === 'swatch') {
          f.displayType = 'SWATCH'
        }
        else if (filter.displayType === 'rating') {
          f.displayType = 'RATING'
        }
        if(filter.values) {
          f.options = filter.values.map((value) => {
            const label = (value.label) ? value.label : value.key;
            return <ISearchFilterOption>{ 
              identifier: value.key.toString(),
              label: label.toString(),
              selected: false,
              records: value.doc_count
            }
          })
        }
        break;
      case 'range':
        f.type = 'RANGE'
        f.displayType = 'RANGE'
        f.options[0] = <ISearchFilterRangeOption>{
          minimum: filter.values.min,
          maximum: filter.values.max,
          selectedMinimum: filter.values.min,
          selectedMaximum: filter.values.max,
          selected: false
        }
        break;
      default:
        throw new Error('Filter type not implemented');
    }
    return f
  })
}

export default mapFilters